import React, {Component} from 'react'
import PropTypes from 'prop-types';
import {connect} from "react-redux";

//Components imports
import ComponentHOC from "../hoc/ComponentHOC";
import PartnersCardItem from "./partners-card";
import Partner from "../models/partner";

class Partners extends Component {
    constructor(){
        super()
        this.state = {
            colSize: 2
        }
    }
    componentDidMount(){
        this.updateValues()
    }
    componentDidUpdate(prev){
        const {screenWidth} = this.props
        if(screenWidth != prev.screenWidth)
            this.updateValues()
    }
    updateValues(){
        const {screenWidth, sizes} = this.props
            for (var [key, value] of Object.entries(sizes)) {
                if(screenWidth >= key)
                    this.setState({
                        colSize: value
                    })
            }
    }
    getTitleName(title){
        var name = title.toLowerCase().replace(/ +/g, "-")
        return name
    }
    render(){
        const {list} = this.props
        const {colSize} = this.state

        return (
            <section className='entertainment-section'>
                <div className="container">
                    <div className='row entertainment-card-list'>
                        {list.map( (cardItem, index) => {
                            var item = new Partner(cardItem)
                            if(window.location.pathname === "/" && index >= colSize)
                                return null
                            return <PartnersCardItem key={item.id} src={item.src} title={item.title} width={12/colSize} link={`parceiros/${item.id}/${this.getTitleName(item.title)}`}/>
                        })}
                    </div>
                </div>
            </section>
        )
    }
}
Partners.propType = {
    size: PropTypes.number,
    list: PropTypes.array.isRequired
}

export default connect(state => state)(ComponentHOC(Partners))


// WEBPACK FOOTER //
// ./src/components/partners.js